import { Config } from '@/config';

// A link other people can open. The web app shares its own origin. The desktop
// app runs at app://aloha, which means nothing to a recipient, so its build
// sets VUE_APP_SHARE_BASE_URL to the web app of the same environment.
const shareBaseUrl = () => Config.shareBaseUrl || window.location.protocol + '//' + window.location.host + '/';

export const shareLink = (id) => shareBaseUrl() + 'tenders' + '/' + id;
